import moment from 'moment'
import { ReportFactoryError } from '../reportFactoryTypes'
import type {
  ReportFactoryConfig,
  ReportFactoryRequest,
} from '../reportFactoryTypes'
import type { ValidatedSearchConditions } from '../types'

export const buildReportFactoryRequest = (
  value: ValidatedSearchConditions,
  config: ReportFactoryConfig
): ReportFactoryRequest => {
  if (
    !/^\d{4}-\d{2}-\d{2}$/.test(value.baseDate) ||
    !moment(value.baseDate, 'YYYY-MM-DD', true).isValid() ||
    (value.groupBy !== 'Currency' && value.groupBy !== 'Class') ||
    typeof value.isAppliedAccountMTD !== 'boolean' ||
    typeof value.useFullFundName !== 'boolean' ||
    !config.configVersion.trim()
  ) {
    throw new ReportFactoryError('INVALID_INPUT')
  }
  const allowedIds = new Set(
    config.portfolios.map(({ portfolioId }) => portfolioId)
  )
  const selectedIds = new Set<number>()
  const portfolios: ReportFactoryRequest['portfolios'] = []
  for (const { portfolioIds, benchmark } of value.rows) {
    if (portfolioIds.length === 0) continue
    if (
      !Number.isFinite(benchmark) ||
      benchmark < 0 ||
      benchmark > 100 ||
      Math.round(benchmark * 10000) / 10000 !== benchmark
    ) {
      throw new ReportFactoryError('INVALID_INPUT')
    }
    for (const portfolioId of portfolioIds) {
      if (!allowedIds.has(portfolioId) || selectedIds.has(portfolioId)) {
        throw new ReportFactoryError('INVALID_INPUT')
      }
      selectedIds.add(portfolioId)
      portfolios.push({ portfolioId, benchmarkPercent: benchmark })
    }
  }
  if (portfolios.length < 1 || portfolios.length > 5) {
    throw new ReportFactoryError('INVALID_INPUT')
  }
  return {
    reportType: 'mtd_performance_hk_excel',
    basedate: value.baseDate,
    configVersion: config.configVersion,
    portfolios,
    groupBy: value.groupBy === 'Currency' ? 'currency' : 'class',
    isAppliedAccountMTD: value.isAppliedAccountMTD,
    useFullFundName: value.useFullFundName,
  }
}
